import React, { useEffect, useState } from "react";
import "./Sidebar.scss";
import { showWebSidebar } from "@App/reducers/global/globalSlice";
import { useAppSelector, useAppDispatch } from "@Src/app/hooks/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRouteURL } from "@Src/routes/app-route-urls";
import ArrowLeft from "../../../assets/images/Arrowleft.svg";
import { manageWebSidebar } from "@App/reducers/global/globalSlice";
import CloseIcon from "../../../assets/images/closeicon.svg";
import useIsMobile from "../../common/IsMobile";
export const Sidebar = (props: any) => {
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();

  const globalStore: any = useAppSelector((state) => state.global);
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState<string>("/dashboard");
  const [isShow, setIsShow] = useState<boolean>(false);

  const location = useLocation();
  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location.pathname]);

  const handleNavigation = (path: string) => {
    setActiveItem(path);
    navigate(path);
  };

  useEffect(() => {
    isMobile
      ? dispatch(manageWebSidebar(false))
      : dispatch(manageWebSidebar(true));
  }, [isMobile, location]);

  const handleSideBarShow = () => {
    dispatch(manageWebSidebar(!globalStore?.manageWebSidebar));
    setIsShow(true);
  };
  return (
    <>
    {globalStore?.manageMobSidebar && ( <div>
      {isMobile && (
        <div
          className="flex items-center gap-2 p-2 w-full rounded mobileMenu "
          onClick={() => handleSideBarShow()}
        >
          <img src={ArrowLeft} alt="" />
          <span>Menu</span>
        </div>
      )}
      </div>
    )}
      

      {globalStore?.manageWebSidebar && (
        <div className={`sidebar-1 fixed-sidebar-1 ${isShow ? "is_show" : ""}`}>
          {isShow && (
            <img
              src={CloseIcon}
              alt="Close"
              className="close-icon"
              onClick={() => {
                setIsShow(false);
                dispatch(manageWebSidebar(!globalStore?.manageWebSidebar));
              }}
            />
          )}

          <div className="sidebar-contents">
            <a onClick={() => navigate('')} className="taxmann-logo"><img src='https://cdn.taxmann.com/learnings/Learning-Logo.png' alt="learning logo" /></a>
            <ul className="sidebar-details">
              <li className={activeItem === "/home" ? "active" : ""}>
                <a
                  href={`/learning/home`}
                  // onClick={() => handleNavigation("/home")}
                  className="sidebar-items"
                >
                  <span className="ui-icons">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.02 2.84016L3.63 7.04016C2.73 7.74016 2 9.23016 2 10.3602V17.7702C2 20.0902 3.89 21.9902 6.21 21.9902H17.79C20.11 21.9902 22 20.0902 22 17.7802V10.5002C22 9.29016 21.19 7.74016 20.2 7.05016L14.02 2.72016C12.62 1.74016 10.37 1.79016 9.02 2.84016Z"
                        stroke="#287682"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 17.9902V14.9902"
                        stroke="#287682"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="sidebar-title"> Home </span>
                </a>
              </li>
              <li className={activeItem === "/upcoming-events" ? "active" : ""}>
                <a
                  href={`/learning/upcoming-events`}
                  // onClick={() =>
                  //   handleNavigation(`/upcoming-events`)
                  // }
                  className="sidebar-items"
                >
                  <span className="ui-icons">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 2V5"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16 2V5"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.5 9.08984H20.5"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.6937 13.6992H15.7027"
                        stroke="#212121"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.6937 16.6992H15.7027"
                        stroke="#212121"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.9945 13.6992H12.0035"
                        stroke="#212121"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.9945 16.6992H12.0035"
                        stroke="#212121"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.29529 13.6992H8.30427"
                        stroke="#212121"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.29529 16.6992H8.30427"
                        stroke="#212121"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="sidebar-title"> Upcoming </span>
                </a>
              </li>
              <li
                className={activeItem === "/events" ? "active" : ""}
              >
                <a
                  href={`/learning/events`}
                  // onClick={() =>
                  //   handleNavigation(`/events`)
                  // }
                  className="sidebar-items"
                >
                  <span className="ui-icons">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 8V13"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 2H15"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="sidebar-title"> Events </span>
                </a>
              </li>

              {/* <li>
                                <a href="javascript:void(0)" className="sidebar-items">
                                    <span className="ui-icons">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.08913 13.2809H9.17913V20.4809C9.17913 22.1609 10.0891 22.5009 11.1991 21.2409L18.7691 12.6409C19.6991 11.5909 19.3091 10.7209 17.8991 10.7209H14.8091V3.52087C14.8091 1.84087 13.8991 1.50087 12.7891 2.76087L5.21913 11.3609C4.29913 12.4209 4.68913 13.2809 6.08913 13.2809Z" stroke="#212121" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <span className="sidebar-title">  Trending </span>
                                </a>
                            </li> */}

              <li className={activeItem === "/subjects" ? "active" : ""}>
                <a
                  href={`/learning/subjects`}
                  // onClick={() =>
                  //   handleNavigation(`/subjects`)
                  // }
                  className="sidebar-items"
                >
                  <span className="ui-icons">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.90024 17H18.0902C19.9902 17 20.9902 16 20.9902 14.1V2H2.99023V14.1C3.00023 16 4.00024 17 5.90024 17Z"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2 2H22"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 22L12 20V17"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16 22L12 20"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.5 11L10.65 8.37C10.9 8.16 11.23 8.22 11.4 8.5L12.6 10.5C12.77 10.78 13.1 10.83 13.35 10.63L16.5 8"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="sidebar-title"> Subjects </span>
                </a>
              </li>
              <li className={activeItem === "/my-list" ? "active" : ""}>
                <a
                  href={`/learning/my-list`}
                  // onClick={() => handleNavigation("/my-list")}
                  className="sidebar-items"
                >
                  <span className="ui-icons">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.53 20.4201H6.21C3.05 20.4201 2 18.3201 2 16.2101V7.79008C2 4.63008 3.05 3.58008 6.21 3.58008H12.53C15.69 3.58008 16.74 4.63008 16.74 7.79008V16.2101C16.74 19.3701 15.68 20.4201 12.53 20.4201Z"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19.5202 17.1001L16.7402 15.1501V8.84013L19.5202 6.89013C20.8802 5.94013 22.0002 6.52013 22.0002 8.19013V15.8101C22.0002 17.4801 20.8802 18.0601 19.5202 17.1001Z"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.5 11C12.3284 11 13 10.3284 13 9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11Z"
                        stroke="#212121"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="sidebar-title">My List </span>
                </a>
              </li>

              {/* <li className="li-footer"> 
                <span className="sidebar-items"> 
                  <span className="ui-icons"> &nbsp; </span>
                  <span className="sidebar-title"> Taxmann.com | Learning </span>
                </span>
                 </li> */}
            </ul>
          </div>
         
        </div>
      )}
    </>
  );
};
